import { ArrowWorkerLoader } from "./arrow-loader.js";
import { parseGeoArrowSync } from "./parsers/parse-geoarrow-sync.js";
import { parseGeoArrowInBatches } from "./parsers/parse-geoarrow-in-batches.js";
export const GeoArrowWorkerLoader = {
  ...ArrowWorkerLoader,
  options: {
    arrow: {
      shape: 'arrow-table'
    }
  }
};
export const GeoArrowLoader = {
  ...ArrowWorkerLoader,
  options: {
    arrow: {
      shape: 'arrow-table'
    }
  },
  parse: async (arraybuffer, options) => parseGeoArrowSync(arraybuffer, options === null || options === void 0 ? void 0 : options.arrow),
  parseSync: (arraybuffer, options) => parseGeoArrowSync(arraybuffer, options === null || options === void 0 ? void 0 : options.arrow),
  parseInBatches: parseGeoArrowInBatches
};
//# sourceMappingURL=geoarrow-loader.js.map